"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BearWorkspaceElements = void 0;
var tslib_1 = require("tslib");
var sdk_model_1 = require("@gooddata/sdk-model");
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var api_1 = require("../../../../utils/api");
var limitingAfmFactory_1 = require("./limitingAfmFactory");
var sdk_backend_base_1 = require("@gooddata/sdk-backend-base");
var BearWorkspaceElements = /** @class */ (function () {
    function BearWorkspaceElements(authCall, workspace) {
        this.authCall = authCall;
        this.workspace = workspace;
    }
    BearWorkspaceElements.prototype.forDisplayForm = function (ref) {
        return new BearWorkspaceElementsQuery(this.authCall, ref, this.workspace);
    };
    BearWorkspaceElements.prototype.forFilter = function (filter, dateFilterDisplayForm) {
        return new BearWorkspaceFilterElementsQuery(this.authCall, filter, dateFilterDisplayForm, this.workspace);
    };
    return BearWorkspaceElements;
}());
exports.BearWorkspaceElements = BearWorkspaceElements;
var BearWorkspaceElementsQuery = /** @class */ (function () {
    function BearWorkspaceElementsQuery(authCall, displayFormRef, workspace) {
        this.authCall = authCall;
        this.displayFormRef = displayFormRef;
        this.workspace = workspace;
        this.limit = 50;
        this.offset = 0;
    }
    BearWorkspaceElementsQuery.prototype.withLimit = function (limit) {
        ts_invariant_1.default(limit > 0, "limit must be a positive number, got: " + limit);
        this.limit = limit;
        return this;
    };
    BearWorkspaceElementsQuery.prototype.withOffset = function (offset) {
        this.offset = offset;
        return this;
    };
    BearWorkspaceElementsQuery.prototype.withAttributeFilters = function (filters) {
        this.attributeFilters = filters;
        return this;
    };
    BearWorkspaceElementsQuery.prototype.withDateFilters = function (filters) {
        this.dateFilters = filters;
        return this;
    };
    BearWorkspaceElementsQuery.prototype.withMeasures = function (measures) {
        this.measures = measures.length > 0 ? measures : undefined;
        return this;
    };
    BearWorkspaceElementsQuery.prototype.withOptions = function (options) {
        this.options = options;
        return this;
    };
    BearWorkspaceElementsQuery.prototype.query = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var limitingAfmFactory, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        limitingAfmFactory = new limitingAfmFactory_1.LimitingAfmFactory(this.authCall, this.displayFormRef, this.workspace);
                        _a = this;
                        return [4 /*yield*/, limitingAfmFactory.getAfm(this.attributeFilters, this.measures, this.dateFilters)];
                    case 1:
                        _a.limitingAfm = _b.sent();
                        return [2 /*return*/, this.queryWorker(this.options)];
                }
            });
        });
    };
    BearWorkspaceElementsQuery.prototype.getObjectId = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var uri;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.objectId) return [3 /*break*/, 2];
                        return [4 /*yield*/, api_1.objRefToUri(this.displayFormRef, this.workspace, this.authCall)];
                    case 1:
                        uri = _a.sent();
                        this.objectId = api_1.getObjectIdFromUri(uri);
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.objectId];
                }
            });
        });
    };
    BearWorkspaceElementsQuery.prototype.queryWorker = function (options) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var objectId;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getObjectId()];
                    case 1:
                        objectId = _a.sent();
                        return [2 /*return*/, sdk_backend_base_1.ServerPaging.for(function (_a) {
                                var limit = _a.limit, offset = _a.offset;
                                return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                    var params, data, _b, items, paging, totalCount;
                                    var _this = this;
                                    return tslib_1.__generator(this, function (_c) {
                                        switch (_c.label) {
                                            case 0:
                                                params = tslib_1.__assign(tslib_1.__assign({}, options), { limit: limit,
                                                    offset: offset, afm: this.limitingAfm });
                                                return [4 /*yield*/, this.authCall(function (sdk) {
                                                        return sdk.md.getValidElements(_this.workspace, objectId, params);
                                                    })];
                                            case 1:
                                                data = _c.sent();
                                                _b = data.validElements, items = _b.items, paging = _b.paging;
                                                totalCount = Number.parseInt(paging.total, 10);
                                                return [2 /*return*/, {
                                                        items: items.map(function (_a) {
                                                            var element = _a.element;
                                                            return element;
                                                        }),
                                                        totalCount: totalCount,
                                                    }];
                                        }
                                    });
                                });
                            }, this.limit, this.offset)];
                }
            });
        });
    };
    return BearWorkspaceElementsQuery;
}());
var BearWorkspaceFilterElementsQuery = /** @class */ (function () {
    function BearWorkspaceFilterElementsQuery(authCall, filter, dateDf, workspace) {
        this.authCall = authCall;
        this.filter = filter;
        this.workspace = workspace;
        this.limit = 50;
        this.offset = 0;
        var ref = sdk_model_1.filterObjRef(filter);
        if (sdk_model_1.isRelativeDateFilter(filter)) {
            ts_invariant_1.default(dateDf, "Date filter's display form needs to be defined");
            ref = dateDf;
        }
        this.elementsQuery = new BearWorkspaceElementsQuery(this.authCall, ref, this.workspace);
    }
    // eslint-disable-next-line sonarjs/no-identical-functions
    BearWorkspaceFilterElementsQuery.prototype.withLimit = function (limit) {
        ts_invariant_1.default(limit > 0, "limit must be a positive number, got: " + limit);
        this.limit = limit;
        return this;
    };
    BearWorkspaceFilterElementsQuery.prototype.withOffset = function (offset) {
        this.offset = offset;
        return this;
    };
    BearWorkspaceFilterElementsQuery.prototype.query = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var selectedElements;
            return tslib_1.__generator(this, function (_a) {
                if (sdk_model_1.isAttributeFilter(this.filter)) {
                    selectedElements = sdk_model_1.filterAttributeElements(this.filter);
                    if (sdk_model_1.isAttributeElementsByRef(selectedElements)) {
                        return [2 /*return*/, this.resultForElementsByRef(selectedElements)];
                    }
                    return [2 /*return*/, this.resultForElementsByValue(selectedElements)];
                }
                else {
                    return [2 /*return*/, this.elementsQuery.withDateFilters([this.filter]).query()];
                }
                return [2 /*return*/];
            });
        });
    };
    BearWorkspaceFilterElementsQuery.prototype.resultForElementsByRef = function (selectedElements) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (selectedElements.uris.length) {
                    return [2 /*return*/, this.elementsQuery
                            .withOptions({
                            uris: selectedElements.uris,
                        })
                            .withOffset(this.offset)
                            .withLimit(this.limit)
                            .query()];
                }
                // Filter with empty selection resolves to empty values
                return [2 /*return*/, Promise.resolve(new sdk_backend_base_1.InMemoryPaging([], this.limit, this.offset))];
            });
        });
    };
    BearWorkspaceFilterElementsQuery.prototype.resultForElementsByValue = function (selectedElements) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var items;
            return tslib_1.__generator(this, function (_a) {
                items = selectedElements.values.map(function (element) { return ({
                    title: element,
                    uri: element,
                }); });
                return [2 /*return*/, Promise.resolve(new sdk_backend_base_1.InMemoryPaging(items, this.limit, this.offset))];
            });
        });
    };
    return BearWorkspaceFilterElementsQuery;
}());
//# sourceMappingURL=index.js.map